var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "additionals-auto-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label" }, [
        _vm._v("Доборные элементы")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar-step-two-img-container additional-img-container"
        },
        [
          _c("img", {
            staticClass: "sidebar-additional-img",
            attrs: { src: _vm.urlForStatic("/img/additionals_auto_tip_1.png") }
          })
        ]
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar-step-two-img-container additional-img-container"
        },
        [
          _c("img", {
            staticClass: "sidebar-additional-img",
            attrs: { src: _vm.urlForStatic("/img/additionals_auto_tip_2.png") }
          })
        ]
      ),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "red-rectangle-button-of-love btn-additional-manual",
          on: { click: _vm.goManualAdditions }
        },
        [_vm._v("\n        Свободное добавление\n    ")]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("\n        Чтобы добавить наличник для окна или двери, "),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("выберите")]),
      _vm._v(" кликом мыши плоскость "),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("оконного")]),
      _vm._v(" или "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("дверного проёма")
      ]),
      _vm._v(" в рабочей области.\n    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("\n        Затем нажмите на кнопку "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v('"добавить наличник"')
      ]),
      _vm._v(
        " на нижней панели. Плоскости доборных элементов будут автоматически созданы вокруг выбранного объекта.\n    "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v(
        "\n        Если Вам необходимо добавить произвольный доборный элемент, воспользуйтесь "
      ),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("свободным добавлением")
      ]),
      _vm._v(".\n    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }